module.exports = __webpack_public_path__ + "static/media/bicycle.3c4d3374.svg";